export default {
    message: {
        "availability": "Disponibilidad",
        "shipping_preparation": "Tiempo estimado de entrega",
        "days": "Días",
        "quantity": "Cantitad",
        "add_to_cart": "Añadir a la cesta",
        "quantity_no_available": "La cantidad solicitada no está disponible actualmente",
        "product_no_available": "Producto próximamente",
        "choose": "Elegir",
        "Loading": "Cargando ...",

    },
}
